import { RECENT_CUSTOMER_KEY, type QERecentCustomer } from "./types"

// QE3 fork of QE2's recent-customer cache. Service line uses this
// to one-tap pre-fill repeat customers in the send screen.
//
// Why fork instead of import: QE2 ("consumer estimate") is a
// customer-self-serve flow — its cache holds the customer's own
// info. QE3 is service-advisor-driven — its cache holds the LAST
// customer the advisor created an estimate for. Different
// semantics, different storage key.

const TTL_MS = 30 * 60 * 1000 // 30 minutes

export function recordRecentCustomer(name: string, phone: string) {
  if (!name.trim() && !phone.trim()) return
  try {
    const cache: QERecentCustomer = {
      name: name.trim(),
      phone: phone.trim(),
      ts: Date.now(),
    }
    localStorage.setItem(RECENT_CUSTOMER_KEY, JSON.stringify(cache))
  } catch {
    // Quota / disabled storage — non-fatal.
  }
}

export function readRecentCustomer(maxAgeMs = TTL_MS): QERecentCustomer | null {
  try {
    const raw = localStorage.getItem(RECENT_CUSTOMER_KEY)
    if (!raw) return null
    const cache = JSON.parse(raw) as QERecentCustomer
    if (Date.now() - cache.ts > maxAgeMs) return null
    return cache
  } catch {
    return null
  }
}
